import * as s from "@gromia/components/theme/t.module.css";
import React from "react";

type Props = {
  children: NonNullable<React.ReactNode>;
};

export const Container = (props: Props) => (
  <div className={s.container}>{props.children}</div>
);

export const Row = (props: Props) => <div>{props.children}</div>;
export const Col = (props: Props) => <div>{props.children}</div>;
